import en from './en/perfection'

let strings

strings=en

export default strings